import { render, staticRenderFns } from "./Easter.vue?vue&type=template&id=6e96772c&scoped=true&"
import script from "./Easter.vue?vue&type=script&lang=js&"
export * from "./Easter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e96772c",
  null
  
)

export default component.exports